'use client';
import { useTheme } from 'styled-components';

import { EmployeeBadgeWrapper, UserName } from './Comment.styled';

export default function CommentAuthor({ user, role }) {
  const theme = useTheme();

  if (role === 'employee')
    return (
      <EmployeeBadgeWrapper title="Prusa Research team member">
        <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7 0L13.9282 4V12L7 16L0.0717969 12V4L7 0Z" fill={theme.custom.colors.brand} />
        </svg>
        <UserName>{user}</UserName>
      </EmployeeBadgeWrapper>
    );

  return <strong>{user}</strong>;
}
